import React from 'react';
import { Route } from 'react-router-dom';
import { ContainerWrapper } from '../../components';
import LayoutsList from './LayoutsList/LayoutsList';

const EmailLayouts = ({ match }) => {
    return (
        <div className="EmailLayouts">
            <ContainerWrapper container="layouts">
                <Route exact path={match.path} component={LayoutsList} />
                <Route exact path={ `${ match.url }/edit/:layoutId` } component={LayoutsList} />
            </ContainerWrapper>
        </div>
    );
}

export default EmailLayouts;
